class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    window.HensslersFreeGift?.sync();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    const timeOut = this.querySelector('cart-drawer-items')?.dataset.items == "1" ? 1000 : 0;
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, timeOut);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    const sectionHtml = parsedState.sections && parsedState.sections['cart-drawer'];
    const kept = sectionHtml && window.holdCartRecommendations?.(sectionHtml);
    if (kept) window.__cartRecoSuppressLoad = true;

    try {
      if (this.querySelector('.drawer__inner').classList.contains('is-empty')) {
        this.getSectionsToRenderEmpty().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      } else if (window.innerWidth < 750) {
        this.getSectionsToRenderMobile().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (section.id == "cart-drawer") {
            document.querySelector('.header-cart').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], '.header-cart');
            document.querySelector('.cart-items').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], '.cart-items');
            document.querySelector('.cart-drawer__footer').innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], '.cart-drawer__footer');
          }
        });
      } else {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      }
    } finally {
      window.__cartRecoSuppressLoad = false;
    }

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');

    if (kept) {
      window.restoreHeldCartRecommendations(kept);
    } else if (window.syncCartRecommendations && sectionHtml) {
      window.syncCartRecommendations(sectionHtml);
    }

    this.updateOrderCountDisplay();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  updateOrderCountDisplay() {
    const containers = this.querySelectorAll('.cart-drawer__order-count');
    if (!containers.length) return;

    let cachedCount = parseInt(sessionStorage.getItem('orderCount') || '', 10);

    containers.forEach((container) => {
      const textElement = container.querySelector('.order-count-text');
      if (!textElement || !textElement.innerHTML.includes('{count}')) return;

      const minCount = parseInt(container.dataset.countFrom, 10) || 15;
      const maxCount = parseInt(container.dataset.countTo, 10) || 50;
      const textTemplate = textElement.innerHTML || container.dataset.countText || '{count} Bestellungen in den letzten 24 Stunden';

      if (!Number.isFinite(cachedCount)) {
        cachedCount = Math.floor(Math.random() * (maxCount - minCount + 1)) + minCount;
        sessionStorage.setItem('orderCount', cachedCount.toString());
      }

      textElement.innerHTML = textTemplate.replace('{count}', cachedCount);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionsToRenderEmpty() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionsToRenderMobile() {
    return [
      {
        id: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.header-cart',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-items',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
